<template>
  <b-card style="position: relative">

    <div v-if="loading" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <b-form @submit.prevent="save">
      <b-row>
        <b-col cols="12">
          <container-form :request-data="requestData" :errors="errors"></container-form>
        </b-col>
        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
            {{ $t('Save') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>

  </b-card>
</template>

<script>

import ContainerForm from '@/views/modules/containers/ContainerForm'
import { OrbitSpinner } from 'epic-spinners'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import RfidForm from '@/views/modules/rfid/components/Form'
import containerStoreModule from '@/app/containers/containerStoreModule'
import { BButton, BCard, BCol, BForm, BFormGroup, BFormInput,
  BInputGroup, BRow, BAlert, BTabs, BTab, BCardText, BTable, BPagination
} from 'bootstrap-vue'
import router from '@/router'


export default {

  name: 'EditContainer',
  directives: { Ripple, },
  components: { RfidForm, BRow, BCard, BCol, BAlert, BTable,BPagination,ContainerForm,
    BFormGroup, BFormInput, BInputGroup, BForm, BButton, BTabs, BCardText, BTab, vSelect, OrbitSpinner
  },

  setup(props, {root}) {

    const CONTAINER_STORE = 'container'
    store.registerModule(CONTAINER_STORE, containerStoreModule)

    onUnmounted(() => {
      if (store.hasModule(CONTAINER_STORE))
        store.unregisterModule(CONTAINER_STORE)
    })


    const loading = ref(false)
    const errors = ref({})

    const requestData = ref({})

    store.dispatch('container/fetchContainer', router.currentRoute.params.id)
    .then(res => requestData.value = res.data.container)


    const toast = (status, msg, title) => {
      root.$bvToast.toast(
          root.$i18n.t(msg),
          { title: title, variant: status, }
      )
    }

    const save = () => {

      loading.value = true
      store.dispatch(`${CONTAINER_STORE}/updateContainer`, {
        id: router.currentRoute.params.id, form: requestData.value
      }).then(res => {
        errors.value = {}
        toast(res.data.status, res.data.message, res.data.title)

      }).catch(e => {
        if (e.response.status === 422) {
          errors.value = e.response.data.errors
          toast('danger', e.response.data.message, 'Error')
        }
      }).finally(() => loading.value = false)
    }

    return {
      loading,
      requestData,
      errors,
      save
    }

  }
}
</script>

<style scoped>

</style>
